export default "__VITE_ASSET__fd92ac24__"